import {allowedContributorTypes} from '../data/apiProvider';


export type ContributorsParamsType = {
    [key: string]: string | number ;
}



export function MapContributorParams(filters:any): ContributorsParamsType {
    let params:ContributorsParamsType = {};
    for(let i in filters){
        switch(i){
            case 'pageSize':
                params[i] = filters[i];
                break;
            case 'eParty':    
                if(filters[i] !== 'All') params[i] = filters[i];
                break;
            case 'type':
                // "all" is every type the site shows. It used to be sent as an empty type, which
                // the API reads as no filter: the All tab listed Commissioners, council, ec_corporate
                // and the -old records too (ops issues/087).
                params[i] = (filters[i] && filters[i] !== 'all')? filters[i] : allowedContributorTypes.join(',');
                break;
            case 'search':
                let searchValue:string = filters[i];
                params['search-value'] = searchValue.split(' ').filter(item => item.length > 0).join('|');
                params['search-type'] = 'contributor';

        }
    }
    if(!params['type']) {
        params['type'] = allowedContributorTypes.join(',');
    }
    return params;
}